import {Flex} from '@priority-software/priority-style-react';
import React from 'react';
import {ChartType} from '../../consts';
import texts from '../../texts';
import styles from '../styles.module.scss';
import {ChatBoxButton} from '../../../../components/Common/Chatbox/ChatBox';
import {ReactComponent as ChartIcon} from '../../../../images/Chart.svg';
import {ReactComponent as WidgetIcon} from '../../../../images/Widget.svg';
import {ReactComponent as ReportIcon} from '../../../../images/Report.svg';
import {ReactComponent as ReportSelected} from '../../../../images/ReportSelected.svg';
import {ReactComponent as ChartSelected} from '../../../../images/ChartSelected.svg';

const ChartTypeButtons = ({setCurrentType, currentType, isUsePredictiveModel}) => {
    const getIconForType = (type: string, active: boolean) => {
        switch (type) {
            case 'report':
                return active ? <ReportSelected /> : <ReportIcon />;
            case 'chart':
                return active ? <ChartSelected /> : <ChartIcon />;
            case 'widget':
                return <WidgetIcon />;
            default:
                return <ReportIcon />;
        }
    };

    return (
        <Flex componentClasses={styles.gap24} justifyContent="space-between">
            {Object.values(ChartType).map(type => {
                const isActive = currentType === type;
                const isDisabled = isUsePredictiveModel && type === ChartType.chart;
                const tooltipProps = isDisabled ? {tooltip: texts.chartExcludedTooltip} : null;
                return (
                    <ChatBoxButton
                        value={type}
                        key={type}
                        text={texts[type]}
                        componentClasses={styles.reportTypeButton}
                        size="large"
                        active={isActive}
                        onClick={() => setCurrentType(type)}
                        icon={getIconForType(type, isActive)}
                        disabled={isDisabled}
                        tooltipProps={tooltipProps}
                    />
                );
            })}
        </Flex>
    );
};

export default ChartTypeButtons;
